<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>Descarbonização e mercado global</h2>
          <p>
            A JBS incrementa a expansão de seu portfólio global de alimentos com
            a aquisição da empresa espanhola BioTech Foods, marcando seu
            ingresso no mercado da proteína cultivada.
          </p>
          <p>
            A companhia adquire a Vivera, terceira maior produtora de produtos
            plant based na Europa, com presença na Holanda, no Reino Unido e na
            Alemanha, e oferta de produtos em mais de 25 países.
          </p>
          <p>
            A compra da Huon Aquaculture, segunda maior produtora de salmão da
            Austrália, marca a entrada no negócio de aquicultura.
          </p>
          <p>
            Em outra frente, na trilha da sustentabilidade, a companhia divulga
            o objetivo de se tornar Net Zero até 2040.
          </p>
        </div>
        <div class="formato__warpper__item--image">
          <img
            src="../assets/img/2021/2021-1.png"
            alt=""
            class="fistItem nohover"
          />
          <img
            src="../assets/img/2021/2021-2.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2021/06/09/g/20210609-46621-nac-33-eco-b9-not-qeeagkk.jpg'
              )
            "
            class="secondItem"
          />
          <img
            src="../assets/img/2021/2021-3.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2021/08/07/g/20210807-46680-spo-38-eco-b12-not-qweqwkk.jpg'
              )
            "
            class="terceiroItem"
          />
          <img
            src="../assets/img/2021/2021-4.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2020/11/14/g/20201114-46414-spo-46-eco-b8-not-hkhhahk.jpg'
              )
            "
            class="quartoItem"
          />
          <img
            src="../assets/img/2021/mulher.jpg"
            alt=""
            class="quintoItem nohover"
          />

          <span
            ><i class="icon-eye"></i
            ><strong>clique nas imagens para ampliar</strong></span
          >
        </div>
        <div class="formato__warpper__item--black">
          <h2>A febre da air fryer</h2>
          <p>
            Criada no final da década de 1980, a fritadeira sem óleo evoluiu
            muito ao longo das décadas seguintes, até o ponto de se tornar não
            só um eletrodoméstico eficiente, mas também o queridinho dos
            brasileiros. Mais conhecido como “<strong><i>air fryer</i></strong
            >”, esse aparelho permite o cozimento e a fritura de alimentos com
            menor quantidade de gorduras, entrando na mira da alimentação
            saudável.
          </p>
          <img
            src="../assets/img/2021/2021-5.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2021/07/18/g/20210718-46660-spo-42-999-h10-not-eghqkkk.jpg'
              )
            "
            class="quartoItem"
          />
        </div>
      </div>
    </div>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from "./Ano.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import { defineComponent } from "vue";

export default defineComponent({
  components: { Ano, VueEasyLightbox },
  props: ["ano"],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
    };
  },
  methods: {
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    openLink(link) {
      window.open(link, "_blank");
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 100px;
    display: grid;
    grid-template-columns: 386px 535px 243px;
    gap: 10px;
    @include media("<=desktop") {
      grid-template-columns: 1fr;
      gap: 0;
    }
  }
  &__warpper {
    position: relative;

    &__item {
      position: relative;
      @include media("<=desktop") {
        padding: 0 20px;
      }
      &--image {
        display: grid;
        position: relative;
        grid-template-columns: 240px 1fr;
        padding-top: 16px;
        margin-left: 20px;
        @include media("<=desktop") {
          padding: 0 20px;
          margin: 30px 0 0;
          grid-template-columns: 1fr;
        }
        img {
          display: block;
          transition: 0.3s ease-in-out;
          cursor: pointer;

          &:hover {
            transform: scale(1.1);
          }
        }
        .fistItem {
          margin-left: auto;
        }
        .secondItem {
          margin-left: -30px;
        }

        .terceiroItem {
          margin-left: auto;
          grid-column: 2;
        }
        .quartoItem {
          grid-column: span 2;
          margin-left: auto;
        }
        .quintoItem {
          margin-top: -100px;
          @include media("<=desktop") {
            grid-column: span 2;
            display: block;
            margin-top: initial;
          }
        }

        span {
          display: block;
          margin: 0 auto;
          width: 65px;
          color: color(cBlue);
          @include media("<=desktop") {
            position: absolute;
            top: 250px;
            left: 20px;
          }
          strong {
            color: color(cWhite);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cBlue);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
      }
      h2 {
        color: color(primary);
        font-family: font(primary);
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
      }
      p {
        color: color(cText);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
      }

      &--black {
        @include media("<=desktop") {
          padding: 40px 20px;
          background: linear-gradient(203deg, #41cdf5 15.5%, #232378 53.33%);
        }
        p {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
          margin-top: 15px;
        }
        h2 {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          text-transform: uppercase;
          margin-bottom: 10px;
          margin-top: 15px;
        }
        blockquote {
          color: color(cBlue);
          font-family: font(primary);
          font-family: JBS Text;
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 135%;
          margin: 10px 0;
          position: relative;
          &::before {
            content: "\e901";
            font-family: "icomoon" !important;
            display: block;
            font-size: 1rem;
            line-height: initial;
            margin-bottom: 17px;
          }
        }
      }
    }
    &::after {
      content: "";
      background: linear-gradient(203deg, #41cdf5 15.5%, #232378 53.33%);
      width: 37%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      z-index: -1;
      background-repeat: no-repeat;
      background-size: cover;
      @include media("<=desktop") {
        display: none;
      }
    }
  }
}
</style>
